import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import ChatBox_NewCaseIn from '../../components/ChatBox_NewCaseIn';
import PrimaryAppBar from '../../components/PrimaryAppBar';

const styles = {
  dialog: {
  },
};

class newCaseDialog extends React.Component {
  state = {

  }

  componentDidMount(){

  }

  render() {
    if(!this.props.isAuthenticated){
      return(<Redirect to='/' />)
    }
    return (
      <div>
        <PrimaryAppBar />
        <ChatBox_NewCaseIn />
      </div>
      
    );
  }
}


const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    //firstTimeSignIn: state.auth.newAccount,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    //onTryAutoSignIn: (newAccount) => dispatch(actions.checkAuthState(newAccount)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(newCaseDialog));